import Row from '../Row';
import NestedControlBlock from '../NestedControlBlock';
import MarkerIconStyleProvider from '../../../providers/MarkerIconStyleProvider';
import * as ids from '../../../layerIdStrings';

export default [
/* 	{
		component: Row,
		props: {
			id: 'corpus_dialekt',
			type: 'markers',
			category: 'layer',
			className: 'js-marker-layer-wrapper js-layer',
			name: 'Zdroje',
			initial: false,
			icon: false,
		}
	}, */

				{
					component: Row,
					props: {
						id: 'dialekt_examples',
						type: 'markers',
						category: 'layer',
						className: 'js-marker-layer-wrapper js-layer',
						value: 'dialekt_examples',
						name: 'Praktická dialektológia (2012)',
						initial: true,
						icon: {
							color: MarkerIconStyleProvider.getColor('dialekt_examples'),
						},
					}
				},

				{
					component: Row,
					props: {
						id: 'ortofon_examples',
						type: 'markers',
						category: 'layer',
						className: 'js-marker-layer-wrapper js-layer',
						value: 'ortofon_examples',
						name: 'Sotácke nárečia severovýchodného Zemplína (2010)',
						initial: true,
						icon: {
							color: MarkerIconStyleProvider.getColor('ortofon_examples'),
						},
					}
				},

				{
					component: Row,
					props: {
						id: 'ucebne_pomocky_examples',
						type: 'markers',
						category: 'layer',
						className: 'js-marker-layer-wrapper js-layer',
						value: 'ucebne_pomocky_examples',
						name: 'Slovenské nárečia – učebné pomôcky (1967)',
						initial: true,
						icon: {
							color: MarkerIconStyleProvider.getColor('ucebne_pomocky_examples'),
						},
					}
				},
/*
				{
					component: Row,
					props: {
						id: 'gemer_examples',
						type: 'markers',
						category: 'layer',
						className: 'js-marker-layer-wrapper js-layer',
						value: 'gemer_examples',
						name: 'Súčasný stav a dynamika nárečia južnej časti stredného Gemera (2019)',
						initial: true,
						icon: {
							color: MarkerIconStyleProvider.getColor('gemer_examples'),
						},
					}
				},
*/
/*
				{
					component: Row,
					props: {
						id: 'dialekt_record_cja',
						type: 'markers',
						category: 'layer',
						className: 'js-marker-layer-wrapper js-layer',
						value: 'dialekt_record_cja',
						name: 'Nahrávky z Českého jazykového atlasu',
						initial: false,
						icon: {
							color: MarkerIconStyleProvider.getColor('dialekt_record_cja'),
						},
					}
				},
*/
];
